<template>
    <div :class="{'  col-sm-6 col-xs-12 ':!service.viewPage , ' col-sm-6 col-xs-12 ':service.viewPage}">
        <span class="text-style-n">
            <label>
                Minimum Charge:
                {{ currency.currency_symbol }}
                {{ service.min_price }}
            </label>
        </span>
        <label class="figma-switch">
            <input ref="minPrice" class="checkbox_consider_min_price" type="checkbox" :checked = "checked" @input="update($event)">
            <span @for="`checkbox_consider_min_price_${service.service_id}_${ service.clone }`"
                  class="slider round"></span>
        </label>
        <input type="hidden" :name="name" :id="id" v-model="value">

    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";

export default {
    name: "MinimumChargeField",
    props: {
        service: {
            type: Object,
            required: true
        },
        currency: {
            required: true
        },
        loggedUser: {
            required: true
        },
        value: false
    },
    data() {
        return {
            checked: this.value
        }
    },
    methods: {
        isContractor() {
            return (this.loggedUser || {}).role_name === "contractor";
        },
        update(e) {
            this.checked = !!$(e.target).attr('checked');
        }
    },
    mounted() {
        if (this.isContractor()) {
            // this.update()
            // this.checked = true;
            // this.checked = false;
        }
    },
    computed :{
        name() {
            if (parseInt(this.service.clone)) {
                return `consider_min_price_${this.service.service_id}_${this.service.clone}`;
            }
            return `consider_min_price_${this.service.service_id}`;
        }   ,
        id() {
            if (parseInt(this.service.clone)) {
                return `consider_min_price_${this.service.service_id}_${this.service.clone}`;
            }

            return `consider_min_price_${this.service.service_id}`;
        }
    },
    watch: {
        checked(value) {
            this.$refs.minPrice.checked = value
            value = value ? 1 : 0
            this.$emit('input', value);
        }
    }
}
</script>

<style scoped>
.text-style-n {
    font-family: Roboto;
    letter-spacing: 0em;
    color: #2E4051;
    text-align: right;
}

@media (max-width: 768px){
    .figma-switch {
        /*float: right;*/
    }
}
</style>